var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { AsyncRequestStatus, getCompletedAsyncWrapperObj, getDefaultAsyncWrapperObj } from "@ane/core/lib/models";
const prefix = "RESOLVE_GATES";
const createActionTypes = (resource) => ({
  LOAD: `${prefix}/${resource}/LOAD'`,
  LOADING: `${prefix}/${resource}/LOADING'`,
  LOADED: `${prefix}/${resource}/LOADED'`
});
const transitionGateActionTypes = createActionTypes("GET_GATE");
const hasGateActionTypes = createActionTypes("HAS_GATE");
const resolveGateActionTypes = createActionTypes("RESOLVE_GATE");
const loadGate = (payload) => {
  return {
    type: transitionGateActionTypes.LOAD,
    payload
  };
};
const loadingGate = () => {
  return {
    type: transitionGateActionTypes.LOADING,
    payload: {
      status: AsyncRequestStatus.Pending
    }
  };
};
const gateLoaded = (payload) => {
  return {
    type: transitionGateActionTypes.LOADED,
    payload: getCompletedAsyncWrapperObj(payload.data, payload.error || "")
  };
};
const loadHasGate = (target, payload) => {
  return {
    type: hasGateActionTypes.LOAD,
    payload: {
      target,
      gate: payload
    }
  };
};
const loadingHasGate = () => {
  return {
    type: hasGateActionTypes.LOADING,
    payload: {
      status: AsyncRequestStatus.Pending
    }
  };
};
const hasGateLoaded = (payload) => {
  return {
    type: hasGateActionTypes.LOADED,
    payload: getCompletedAsyncWrapperObj(payload.data, payload.error || "")
  };
};
const resolveGate = (payload) => {
  return {
    type: resolveGateActionTypes.LOAD,
    payload
  };
};
const resolvingGate = () => {
  return {
    type: resolveGateActionTypes.LOADING,
    payload: {
      status: AsyncRequestStatus.Pending
    }
  };
};
const gateResolved = (payload) => {
  return {
    type: resolveGateActionTypes.LOADED,
    payload
  };
};
const defaultReducerState = {
  async: getDefaultAsyncWrapperObj(),
  gate: getDefaultAsyncWrapperObj(),
  has_gate: getDefaultAsyncWrapperObj()
};
const resolveGateReducer = (state = defaultReducerState, action) => {
  switch (action.type) {
    case resolveGateActionTypes.LOAD:
    case resolveGateActionTypes.LOADING:
    case resolveGateActionTypes.LOADED:
      return __spreadProps(__spreadValues({}, state), {
        async: action.payload
      });
    case transitionGateActionTypes.LOADING:
    case transitionGateActionTypes.LOADED:
      return __spreadProps(__spreadValues({}, state), {
        gate: action.payload
      });
    case hasGateActionTypes.LOADING:
    case hasGateActionTypes.LOADED:
      return __spreadProps(__spreadValues({}, state), {
        has_gate: action.payload
      });
    default:
      return state;
  }
};
export {
  createActionTypes,
  defaultReducerState,
  gateLoaded,
  gateResolved,
  hasGateActionTypes,
  hasGateLoaded,
  loadGate,
  loadHasGate,
  loadingGate,
  loadingHasGate,
  resolveGate,
  resolveGateActionTypes,
  resolveGateReducer,
  resolvingGate,
  transitionGateActionTypes
};
//# sourceMappingURL=ResolveGate.ducks.js.map
